import {ActionReducerMap, ActionReducer, MetaReducer, createFeatureSelector, createSelector} from '@ngrx/store';
import { environment } from '../../environments/environment';
import * as fromAppConfig from './appconfig.reducer';

/**
 * storeFreeze prevents state from being mutated. When mutation occurs, an
 * exception will be thrown. This is useful during development mode to
 * ensure that none of the reducers accidentally mutates the state.
 */
import { storeFreeze } from 'ngrx-store-freeze';

export interface State {
    appConfig: fromAppConfig.AppConfigState
    // more state here
}

export const reducers: ActionReducerMap<State> = {
    appConfig: fromAppConfig.reducer
    // more reducers here
};


// console.log all actions
export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
    return function(state: State, action: any): State {
        //console.log('state', state);
        //console.log('action', action);

        return reducer(state, action);
    };
}

/**
 * By default, @ngrx/store uses combineReducers with the reducer map to compose
 * the root meta-reducer. To add more meta-reducers, provide an array of meta-reducers
 * that will be composed to form the root meta-reducer.
 */
export const metaReducers: MetaReducer<State>[] = !environment.production
    ? [logger, storeFreeze]
    : [];


/// selectors
export const getAppConfigState = createFeatureSelector<fromAppConfig.AppConfigState>('appConfig');

export const getAppVersion = createSelector(getAppConfigState, fromAppConfig.getAppVersion);



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/reducers/index.ts